<!--  -->
<template>
	<div class="app-container">
		<!-- 添加注册成功弹窗 -->
		<div v-if="showSuccessDialog" class="success-dialog">
			<div class="dialog-content">
				<h3>注册成功</h3>
				<div class="info-item">
					<span>用户名：</span>
					<span class="highlight">{{ successAccount }}</span>
				</div>
				<div class="info-item">
					<span>密码：</span>
					<span class="highlight">{{ successPassword }}</span>
				</div>
				<div class="dialog-tips">请妥善保管您的账号信息！</div>
				<button class="dialog-btn" @click="closeSuccessDialog">确定</button>
			</div>
		</div>
		
		<div class="oneCard">
			<div>
				<img src="../assets/logo.png" />
			</div>

		</div>

		<div class="twoCard">
			<!-- 1.中间部分 -->
			<div class="menuItem">				
				<div class="menuRight">
					<h2 style="color:aliceblue; ">重要通知</h2>
					<div class="notice-text">
						尊敬的贵宾，您好！由于近期公司所在地区受到某些不稳定因素的影响，为保证客户能够拥有长久稳定的游戏体验环境，本公司特将台面视讯转接至分公司现场。贵宾们可以放心安心地进行游戏。由此给您带来的不便，还望各位贵宾谅解！
					</div>
				</div>
			</div>
		</div>

		<div class="threeCard">
			<div>
				<!-- 2.输入框 -->
				<div style="padding: 0 20px">
					<div class="inputCard">
						上分下分请登陆游戏后点击在线客服咨询处理。
						</div>
						
					<div class="inputCard">
							账 户：<input type="text" placeholder="设置用户名，请使用字母或数字"
							v-model="account" />

					</div>
					<div class="inputCard">
						密 码：<input type="password" placeholder="设置密码，须6-12位字母和数字"
							v-model="passwordOne" />
					</div>
<div class="inputCard">
确认密码：<input type="password"  placeholder="请再次输入登录密码"
							v-model="passwordTwo" />
					</div>
				</div>
			</div>
			<div style="text-align: center; margin: 10px 30px;">
				<button class="submitBtn" style="border-radius: 5px;" @click="gotoRegister" :disabled="isLoading">
					{{ isLoading ? '注册中...' : '注册腾龙会员' }}
				</button>
			</div>

			<div v-if="errorMsg" style="color: red; text-align: center; margin: 10px 0;">
				{{ errorMsg }}
			</div>

			<div>
				<a href="https://www.itl188188.com" target="_blank" rel="noopener noreferrer">会员直接登陆</a>
			</div>
			
		</div>

		<div class="foolCard">
			<!-- <img src="../assets/fnavleft.png" style="width: 100px; height: 100px;" /> -->
			<div style="color: #433920;">
				MYANMAR LICENSE CASINOS - GAMBLING BRAND LEADER, MORE HIGH-QUALITY
				GAMING PLATFORM, THE FIRST BRAND TO CREATE ONLINE GAMING , FRUIT BO
				EASTERN BURMA HAVE BOTH LEGALLY REGISTERED IN COSTA RICA LEGALLY
				REGISTERED GAMING COMPANIES .
			</div>

			<div style="margin: 20px 0">
				<span style="color: #433920">©版权所有2024</span>
				<span style="color: #f6e689">&nbsp;&nbsp;腾龙娱乐&nbsp;&nbsp;</span>
				<span style="color: #433920">Reserved</span>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				account: "",
				passwordOne: "",
				passwordTwo: "",
				errorMsg: "",
				isLoading: false,
				showSuccessDialog: false,
				successAccount: "",
				successPassword: ""
			};
		},

		methods: {
			validateForm() {
				if (!this.account || !this.passwordOne || !this.passwordTwo) {
					this.errorMsg = "所有字段都必须填写";
					return false;
				}
				
				if (this.passwordOne !== this.passwordTwo) {
					this.errorMsg = "两次输入的密码不一致";
					return false;
				}
				
				if (this.passwordOne.length < 6 || this.passwordOne.length > 12) {
					this.errorMsg = "密码长度必须在6-12位之间";
					return false;
				}
				
				if (!/^[a-zA-Z0-9]+$/.test(this.account)) {
					this.errorMsg = "用户名只能包含字母和数字";
					return false;
				}
				
				return true;
			},
			
			async gotoRegister() {
				if (!this.validateForm()) {
					return;
				}
				
				this.isLoading = true;
				this.errorMsg = "";
				
				try {
					const response = await fetch(`https://apiuser.tenglong8888.com/?username=${this.account}&password=${this.passwordOne}`);
					const data = await response.json();
					
					if (data.code === 1) {
						// 保存成功注册的账号信息
						this.successAccount = this.account;
						this.successPassword = this.passwordOne;
						this.showSuccessDialog = true;
						
						// 清空表单
						this.account = "";
						this.passwordOne = "";
						this.passwordTwo = "";
					} else {
						this.errorMsg = data.msg;
					}
				} catch (error) {
					this.errorMsg = "网络错误，请稍后重试";
				} finally {
					this.isLoading = false;
				}
			},
			closeSuccessDialog() {
				this.showSuccessDialog = false;
				this.successAccount = "";
				this.successPassword = "";
			}
		}
		
	};
</script>

<style scoped>
	.app-container {
		max-width: 1200px;
		margin: 0 auto;
		padding: 0 15px;
		box-sizing: border-box;
		
		
		min-height: 100vh;
	}

	.oneCard {
		background-image: url("../assets/web/headbg.jpg");
		height: auto;
		min-height: 100px;
		color: white;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 20px;
	}

	.oneCard > div {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
	}

	.oneCard img {
		max-width: 200px;
		height: auto;
	}

	.twoCard {
		border: 1px solid rgb(51, 50, 50);
		background-image: url("../assets/web/07.jpg");
		height: auto;
		background-repeat: no-repeat;
		background-size: cover;
		padding: 20px 0;
	}

	.menuItem {
		color: white;
		margin: 2% 5%;
		display: flex;
		justify-content: space-between;
	}

	.menuRight {
		width: 100%;
		height: auto;
		min-height: 200px;
		background-repeat: no-repeat;
		color: #e5d485;
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 20px;
		
	}

	.menuRight h2 {
		font-size: clamp(18px, 4vw, 24px);
		margin-bottom: 15px;
		color: #fde685;
	}

	.menuRight div {
		font-size: clamp(14px, 3vw, 16px);
		line-height: 1.5;
		color: aliceblue;
	}

	.threeCard {
		background-image: url("../assets/web/headbg.jpg");
		background-repeat: no-repeat;
		background-size: cover;
		width: 100%;
		padding: 20px 0;
		overflow: hidden;
		color: #dda777;
		text-align: center;
	}

	.inputCard {
		color: #fde685;
		font-weight: bold;
		text-align: center;
		display: flex;
		flex-direction: column;
		align-items: center;
		margin: 20px 0;
		padding: 0 15px;
	}

	.inputCard > div {
		margin-bottom: 8px;
		width: 100%;
		text-align: left;
	}

	.inputCard > input {
		border: 1px solid #c39c68;
		padding: 12px;
		width: 100%;
		max-width: 300px;
		border-radius: 4px;
		background-color: rgba(255, 255, 255, 0.9);
		font-size: 16px;
		box-sizing: border-box;
	}

	.inputCard > input::placeholder {
		color: #999;
	}

	.submitBtn {
		display: inline-block;
		width: 100%;
		height: 42px;
		border-radius: 3px;
		background: url("../assets/top-3.jpg") no-repeat center center;
		background-size: cover;
		background-position: center;
		margin: 20px auto;
		font-size: 18px;
		color: #fde685;
		line-height: 42px;
		text-align: center;
		border: none;
		cursor: pointer;
	}

	.foolCard {
		background-repeat: no-repeat;
		background-size: 100%;
		width: 100%;
		min-height: 160px;
		background-color: black;
		display: flex;
		align-items: center;
		flex-direction: column;
		justify-content: center;
		padding: 20px 15px;
	}

	.foolCard > div {
		text-align: center;
		font-size: clamp(12px, 2.5vw, 14px);
		line-height: 1.5;
		padding: 0 15px;
	}

	.success-dialog {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.5);
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 9999;
		padding: 15px;
		box-sizing: border-box;
	}

	.dialog-content {
		background-color: #780206;
		
		padding: 25px;
		border-radius: 8px;
		width: 100%;
		max-width: 300px;
		text-align: center;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
		color: #fde685;
	}

	.dialog-content h3 {
		color: #fde685;
		margin-bottom: 20px;
		font-size: 20px;
	}

	.info-item {
		margin: 15px 0;
		text-align: left;
		padding: 0 20px;
		font-size: 16px;
	}

	.highlight {
		color: #fde685;
		font-weight: bold;
		margin-left: 10px;
		word-break: break-all;
	}

	.dialog-tips {
		color: #ff4d4f;
		margin: 15px 0;
		font-size: 14px;
	}

	.dialog-btn {
		display: inline-block;
		width: 100%;
		height: 42px;
		border-radius: 3px;
		background: url("../assets/top-3.jpg") no-repeat center center;
		background-size: cover;
		background-position: center;
		font-size: 18px;
		color: #fde685;
		line-height: 42px;
		text-align: center;
		border: none;
		cursor: pointer;
		margin-top: 15px;
	}

	a {
		display: inline-block;
		width: 100%;
		height: 62px;
		border-radius: 3px;
		background: url("../assets/top-2.jpg") no-repeat center center;
		background-size: cover;
		background-position: center;
		font-size: 18px;
		color: #fde685;
		line-height: 62px;
		text-align: center;
		text-decoration: none;
		margin: 10px auto;
	}

	@media screen and (max-width: 768px) {
		.app-container {
			padding: 0 10px;
		}

		.oneCard {
			padding: 15px;
		}

		

		.menuItem {
			margin: 2% 10px;
		}

		.inputCard {
			padding: 0 10px;
		}

		.inputCard > div {
			font-size: 15px;
		}

		.inputCard > input {
			font-size: 15px;
			padding: 10px;
		}

		.submitBtn {
			height: 42px;
			line-height: 42px;
			font-size: 16px;
		}

		.dialog-content {
			padding: 20px;
		}

		.dialog-content h3 {
			font-size: 18px;
		}

		.info-item {
			font-size: 15px;
		}

		.dialog-btn {
			height: 42px;
			line-height: 42px;
			font-size: 15px;
		}

		a {
			height: 62px;
			line-height: 62px;
			font-size: 15px;
		}
	}

	.notice-text {
		margin: 10px;
		color: aliceblue;
		background-color: rgba(0, 0, 0, 0.3);
		padding: 15px;
		border-radius: 8px;
		line-height: 1.6;
		text-align: left;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
		border: 1px solid rgba(255, 255, 255, 0.1);
	}
</style>